module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert bottom"
  }, [_c('mu-card', {
    class: [_vm.type]
  }, [_c('mu-card-text', [_c('div', {
    staticClass: "alert-left",
    class: {
      topAlign: _vm.align === 'top',
      middleAlign: _vm.align === 'middle'
    }
  }, [_c('mu-icon', {
    staticClass: "flex",
    attrs: {
      "value": _vm.icon
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "alert-body",
    class: {
      topAlign: _vm.align === 'top',
      middleAlign: _vm.align === 'middle'
    }
  }, [_vm._t("content")], 2), _vm._v(" "), _c('div', {
    staticClass: "alert-after",
    class: {
      topAlign: _vm.align === 'top',
      middleAlign: _vm.align === 'middle'
    }
  }, [_vm._t("after")], 2), _vm._v(" "), _c('div', [_vm._t("action")], 2)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f388212","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert/Alert.vue
// module id = 3109
// module chunks = 1